import React, { useMemo } from "react";
import { Container } from "react-bootstrap";
import getSimData from "../../../inputData/simData";
import RowSelectingTable from "./RowSelectingTable";
import { useTranslation } from "react-i18next";

const RowExpanding = (props) => {
  const { t } = useTranslation();
  const { simColumns } = useMemo(() => getSimData(t), [t]);
  const generateCustomFieldColumns = (customFields) => {
    return customFields.map((field) => {
      return {
        id: field.displayName,
        Header: field.displayName,
        accessor: (sim) => {
          const customValue = sim.customFieldValues.find(
            (v) => v.custom_field_id === field.id
          );

          return customValue ? customValue.value : "";
        },

        filterType: field.type,
        canRenderFilter: true,
        sortable: true,
      };
    });
  };

  const customColumns =
    props.demoMode === false
      ? generateCustomFieldColumns(props.customFields)
      : [];
  const allColumns = [...simColumns, ...customColumns];

  return (
    <React.Fragment>
      <Container fluid className="p-0">
        <RowSelectingTable
          columns={allColumns}
          data={props.data}
          setOpen={props.setOpen}
          setSingleIsShown={props.setSingleIsShown}
          shownSim={props.shownSim}
          setShownSim={props.setShownSim}
          pageNumber={props.page}
          setPageNumber={props.setPage}
          pageRecords={props.pageSize}
          setPageRecords={props.setPageSize}
          numberOfRecords={props.numberOfRecords}
          setCellInfo={props.setCellInfo}
          filters={props.filters}
          setFilters={props.setFilters}
          isLoading={props.isLoading}
          setIsLoading={props.setIsLoading}
          selectedRows={props.selectedRows}
          setSelectedRows={props.setSelectedRows}
          customFields={props.customFields}
          sort={props.sort}
          setSort={props.setSort}
          demoMode={props.demoMode}
        />
      </Container>
    </React.Fragment>
  );
};

export default RowExpanding;
